import {
  apiTipoUnidadMedida,
  ArticuloApiInputProps,
  ArticuloInputProps,
} from '../../../interfaces/articulo.ts'
import { genReplaceEmpty } from '../../../utils/helper'

/**
 * Componemos los datos del articulo para su posterior upsert
 * @param data
 */
export const articuloInputToApi = (
  data: ArticuloInputProps,
): {
  codigoArticulo: string
  input: ArticuloApiInputProps
} => {
  const codigoUnidadRef =
    data.tipoUnidadMedida === apiTipoUnidadMedida.articuloUnidadMedida
      ? data.unidadMedida!.codigoUnidadMedida
      : data.grupoUnidadMedida!.codigoGrupo
  const input: ArticuloApiInputProps = {
    nombreArticulo: data.nombreArticulo,
    descripcionArticulo: data.descripcionArticulo,
    codigoSinProducto: data.sinProductoServicio!.codigoProducto,
    codigoActividad: data.actividadEconomica!.codigoActividad,
    codigoGrupoArticulo: genReplaceEmpty(data.grupoArticulo?.codigoGrupoArticulo, null),
    codigoTipoArticulo: genReplaceEmpty(data.tipoArticulo?.codigo, null),
    codigoProveedor: data.proveedor.map((p) => p.codigo),
    articuloVenta: data.articuloVenta,
    articuloCompra: data.articuloCompra,
    articuloProduccion: data.articuloProduccion ?? false,
    claseArticulo: data.claseArticulo!.key,
    gestionArticulo: data.gestionArticulo ? data.gestionArticulo.key : null,
    tipoUnidadMedida: data.tipoUnidadMedida,
    codigoUnidadRef,
    verificarStock: data.verificarStock,
    activo: data.activo,
  }
  return { codigoArticulo: data.codigoArticulo, input }
}
